// Dynamic font loader for Google Fonts
const loadedFonts = new Set<string>();

export async function loadGoogleFonts(fonts: string[]): Promise<void> {
  const fontsToLoad = fonts.filter(font => !loadedFonts.has(font));
  
  if (fontsToLoad.length === 0) {
    return; // All fonts already loaded
  }
  
  // Create Google Fonts URL
  const fontFamilies = fontsToLoad.map(font => {
    // Replace spaces with + for URL
    const urlFont = font.replace(/ /g, '+');
    // Add common weights
    return `${urlFont}:wght@300;400;500;600;700;800`;
  }).join('&family=');
  
  const googleFontsUrl = `https://fonts.googleapis.com/css2?family=${fontFamilies}&display=swap`;
  
  // Check if link already exists
  const existingLink = document.querySelector(`link[href="${googleFontsUrl}"]`);
  if (existingLink) {
    fontsToLoad.forEach(font => loadedFonts.add(font));
    return;
  }
  
  // Create and append link element
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = googleFontsUrl;
  
  // Wait for fonts to load
  return new Promise((resolve, reject) => {
    link.onload = () => {
      fontsToLoad.forEach(font => loadedFonts.add(font));
      resolve();
    };
    link.onerror = () => {
      console.error('Failed to load fonts:', fontsToLoad);
      reject(new Error('Font loading failed'));
    };
    
    document.head.appendChild(link);
  });
}

// Preload commonly used fonts
export function preloadCommonFonts() {
  const commonFonts = [
    'Roboto',
    'Open Sans',
    'Inter',
    'Fira Code'
  ];
  
  loadGoogleFonts(commonFonts).catch(err => {
    console.warn('Failed to preload common fonts:', err);
  });
}